import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { setAccessToken, authApi } from '@/api';
import type { LoginRequest, UserProfile } from '@/types/user';

interface AuthState {
  profile: UserProfile | null;
  authenticated: boolean;
  loading: boolean;
  login: (payload: LoginRequest) => Promise<void>;
  logout: () => Promise<void>;
  refreshProfile: () => Promise<void>;
  patchProfile: (next: Partial<UserProfile>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      profile: null,
      authenticated: false,
      loading: false,

      async login(payload) {
        set({ loading: true });
        try {
          const result = await authApi.login(payload);
          setAccessToken(result.accessToken);
          set({ profile: result.profile, authenticated: true });
        } finally {
          set({ loading: false });
        }
      },

      async logout() {
        try {
          await authApi.logout();
        } catch {
          /* 容忍后端清场失败 */
        }
        setAccessToken(null);
        set({ profile: null, authenticated: false });
      },

      async refreshProfile() {
        const profile = await authApi.me();
        set({ profile, authenticated: true });
      },

      patchProfile(next) {
        const current = get().profile;
        if (!current) return;
        set({ profile: { ...current, ...next } });
      },
    }),
    {
      name: 'up-card-auth',
      partialize: (state) => ({
        profile: state.profile,
        authenticated: state.authenticated,
      }),
    },
  ),
);
